<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/AS_AllDocuments">
                      নথি
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>বিদ্যুৎ উপভোক্তাৰ কৰ্তব্য</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
          <div class="cntnt">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">বিদ্যুৎ উপভোক্তাৰ কৰ্তব্য</h1>
              </b-col>
           </b-row>

                  <p class="content">
                    <ul class="a">
                   <li>শক্তিৰ ব্যৱহাৰ হ্ৰাস কৰিবলৈ শক্তি দক্ষ সঁজুলি ব্যৱহাৰ কৰক। সঞ্চয় কৰা শক্তি হ 'ল উৎপাদিত শক্তি।</li>
                   <li>এপিডিচিএলক অবিৰত আৰু নিৰ্ভৰযোগ্য বিদ্যুৎ যোগান প্ৰদান কৰিবলৈ নিয়মীয়াভাৱে বিদ্যুৎ বিল পৰিশোধ কৰক। কেৱল এপিডিচিএল অনুমোদিত নগদ কাউণ্টাৰত বা অনলাইন মোড www.apdcl.org বা 
                    এপিডিচিএলৰ দ্বাৰা অনুমোদিত আন যিকোনো অনলাইন মোডৰ জৰিয়তে বিল পৰিশোধ কৰক আৰু সঠিক ৰচিদ প্ৰাপ্ত কৰক।</li>
                   <li>সকলো বৈদ্যুতিক সঁজুলিৰ সঠিক সুৰক্ষা বজাই ৰাখক। যোগানৰ স্থানৰ ওচৰত সদায় অভাৰলোড আৰু শ্বৰ্ট চাৰ্কিট সুৰক্ষা (চাৰ্কিট ব্ৰেকাৰ/চুইচ) ৰ দৰে সুৰক্ষা সঁজুলি স্থাপন কৰক।</li>
                   <li>বৈদ্যুতিক দুৰ্ঘটনাৰ প্ৰতিবেদন দিয়ক আৰু এনে দুৰ্ঘটনা প্ৰতিৰোধ কৰিবলৈ প্ৰয়োজনীয় সাৱধানতা অৱলম্বন কৰক। প্ৰাকৃতিক দুৰ্যোগৰ সময়ত বৈদ্যুতিক লাইন আদি ভাঙি যোৱাৰ ফলত হোৱা যিকোনো দুৰ্ঘটনাৰ পৰা হাত সাৰিবলৈ অতিৰিক্ত সুৰক্ষা ব্যৱস্থা গ্ৰহণ কৰক।</li>
                   <li>এপিডিচিএলৰ কৰ্মচাৰীসকলৰ সৈতে সহযোগিতা কৰক আৰু এপিডিচিএলক উন্নত সেৱা প্ৰদান কৰিবলৈ তেওঁলোকৰ কৰ্তব্য পালনৰ বাবে পৰিসৰ উপলব্ধ কৰাওক।</li>
                   <li>এপিডিচিএল অনুসৰি মিটাৰিং আৰু আনুষংগিক সঁজুলিবোৰক পৰ্যাপ্ত সুৰক্ষা প্ৰদান আৰু ৰক্ষণাবেক্ষণ কৰক।</li>
                   <li>এ. পি. ডি. চি. এল.-ৰ দ্বাৰা প্ৰদান কৰা বৈদ্যুতিক প্ৰকল্প, লাইন বা মিটাৰিং সঁজুলিৰ ক্ষতি বা ক্ষতি কৰাৰ অনুমতি নিদিব।</li>
                   <li>যদি গ্ৰাহকে জানিব পাৰে যে মিটাৰিং সঁজুলিটোৰ সুৰক্ষামূলক মোহৰটো ভাঙি গৈছে, তেন্তে তেওঁ তৎক্ষণাত এপিডিচিএলক অৱগত কৰিব।</li>
                   <li>পৰিসৰত স্থাপন কৰা মিটাৰ ব্যৱস্থাকে ধৰি যোগানৰ মুখ্য বা সঁজুলিৰ ক্ষেত্ৰত হস্তক্ষেপ নকৰিব।</li>
                   <li>আপোনাৰ পৰিসৰত স্বাস্থ্যকৰ বৈদ্যুতিক ভূমি সংযোগ স্থাপন কৰাটো নিশ্চিত কৰক।</li>
                   <li>নিশ্চিত কৰক যে আপোনাৰ সংস্থাপনৰ বাবে কেৱল সঠিক ক্ষমতাৰ আই. এছ. চিহ্নিত তাঁৰ ব্যৱহাৰ কৰা হৈছে আৰু কেৱল অনুজ্ঞাপত্ৰপ্ৰাপ্ত বৈদ্যুতিক ঠিকাদারৰ জৰিয়তে তাঁৰ নিৰ্মাণ কৰা হৈছে।</li>
                   <li>প্ৰধান চুইচবোৰত সদায় সঠিক ক্ষমতাৰ ফিউজ তাঁৰ ব্যৱহাৰ কৰক।</li>
                   <li>সঠিক ভোল্টেজ পাবলৈ, আৰোহী লোডৰ বাবে পৰ্যাপ্ত কেপাচিটাৰ স্থাপন কৰক।</li>
                   <li>আপোনাৰ পৰিসৰত শক্তি মিটাৰ আৰু মিটাৰিং সঁজুলিৰ সুৰক্ষা নিশ্চিত কৰক। মিটাৰ আৰু মিটাৰিং সঁজুলিসমূহক বতৰৰ প্ৰতিৰোধী বেষ্টনী প্ৰদান কৰক।</li>
                   <li>সংস্থাপন পৰীক্ষা কৰাৰ বাবে যোগান ধৰাৰ সময়ত অনুজ্ঞাপত্ৰপ্ৰাপ্ত বৈদ্যুতিক ঠিকাদাৰ বা তেওঁৰ অনুমোদিত প্ৰতিনিধি আপোনাৰ পৰিসৰত উপস্থিত থকাটো নিশ্চিত কৰক।</li>
                   <li>মিটাৰ ৰিডিং লোৱাৰ বাবে মূল্যায়নকাৰী ওচৰলৈ সহজে যাব প​ৰাকৈ তলৰ মহলাত এটা সুবিধাজনক স্থানত মিটাৰ স্থাপন কৰাৰ বাবে ঠাই প্ৰদান কৰক।</li>
                   <li>বহু মহলীয়া অট্টালিকাবোৰত, মজিয়াৰ সংখ্যা নিৰ্বিশেষে, কেৱল তলৰ মহলাত মিটাৰ, কাট-আউট আদি ঠিক কৰাৰ বাবে ঠাই প্ৰদান কৰক।</li>
                   <li>লাইট, ফেন আদিৰ দৰে অতিৰিক্ত লোড আৰু অন্যান্য বৈদ্যুতিক সঁজুলি যেনে ৰেফ্ৰিজেটাৰ, এয়াৰ কণ্ডিছনাৰ, ৱাটাৰ হিটাৰ আদি সংযোগ কৰোঁতে মিটাৰৰ ক্ষমতা পৰ্যাপ্ত হোৱাটো নিশ্চিত কৰক।</li>
                   <li>যদি মিটাৰৰ ক্ষমতা পৰ্যাপ্ত নহয়, উচ্চ ক্ষমতাৰ মিটাৰ স্থাপনৰ বাবে সংশ্লিষ্ট উপ-সংমণ্ডলৰ বিষয়াসকলৰ সৈতে যোগাযোগ কৰক।</li>
                   <li>বিদ্যুৎ কেৱল সেই উদ্দেশ্যেহে ব্যৱহাৰ কৰক যাৰ বাবে সেৱা সংযোগ দিয়া হৈছে।</li>
                   <li>ভাৰতীয় বিদ্যুৎ নিয়ম ১৯৫৬ অনুসৰি বৰ্তমানৰ হাই টেনচন/লো টেনচন লাইনৰ পৰা সঠিক অনুমতি লৈ আপোনাৰ ঘ​ৰ নিৰ্মাণ কৰক।(vide rule 79 & 80)</li>
                   <li>যদি ঘ​ৰৰ পৰ্য্যাপ্ত সন্মুখভাগ নাই আৰু লাইনটো আন মালিকসকলৰ কাষৰীয়া চৌহদৰ মাজেৰে বা ওপৰেৰে যাব
                     লগা হয় তেন্তে লাইনবোৰ নিয়াৰ বাবে আপোনাৰ নিজৰ খৰচতে প্ৰয়োজনীয় পথ-প্ৰস্থানৰ ব্যৱস্থা কৰক।</li>
                   <li>যদি মুঠ সংযুক্ত লোড ৪০০০ ৱাট অৰ্থাৎ ৪ কিলোৱাটতকৈ অধিক হয় তেন্তে আপোনাৰ যোগান একক-ফেজৰ পৰা তিনি ফেজলৈ ৰূপান্তৰিত কৰক।</li>
                   <li>ত্ৰুটিপূৰ্ণ বৈদ্যুতিক অংশসমূহ আৰু সঁজুলিবোৰ তৎক্ষণাত সলনি কৰক।</li>
                   <li>যদি মিটাৰটো ত্ৰুটিপূৰ্ণ আৰু চলি থকা নাই বুলি ধৰা পৰে তেন্তে বিষয়টো লিখিতভাৱে উপ-সংমণ্ডলৰ বিষয়াসকলৰ দৃষ্টিগোচৰ কৰি সুস্থ মিটাৰ এটাৰে সলনি কৰক।।</li>
                   <li>কেৱল বিদ্যুৎ লিক হোৱাৰ পৰা ৰক্ষা কৰাই নহয়, পৰিসৰত থকা লোকসকলৰ জীৱন সুৰক্ষিত কৰাৰ বাবেও সময়ে সময়ে আভ্যন্তৰীণ তাঁৰ পৰীক্ষা কৰাওক।</li>
                    </ul>
                  </p>
                </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import Cards from '@/components/DocumentCardComponents.vue'
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'


export default {
  name: 'Document',
  components: {
    'Cards' : Cards,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
  }
}
</script>

<style scoped="true">
li{
  padding:0;
}
ul.a {
  list-style-type: circle;
  padding-left:30px;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
